class DomainError extends Error {
    constructor(message) {
        super(message);
        this.name = this.constructor.name;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
        };
    }
}
export class ValidationError extends DomainError {
    errors;
    constructor(message, errors = []) {
        super(message);
        this.errors = errors;
    }
    toJSON() {
        return {
            ...super.toJSON(),
            errors: this.errors,
        };
    }
}
export class ServerError extends DomainError {
}
export class UnauthorizedError extends DomainError {
}
